<template>
    <div class="greybox">
        <div v-if="selectedGadget.repairOption">
            <h1>{{selectedGadget.repairOption.displayName}}</h1>
            <p>Are you sure you want to cancel this repair option?</p>
            <p>If you have already paid your excess you will not be asked again.</p>
            <br />
            <div class="button-fluid-container">
              <button
                  class="button"
                  @click="() => { this.$router.go(-1)}">
                  Close
              </button>
              <button
                  class="button"
                  @click="handleCancelOptionClick(selectedGadget.id)">
                  Cancel repair option
              </button>
              <button
                  class="button"
                  @click="handleCancelOptionClick(selectedGadget.id, {path: '/myclaims/repairoptions/list/'})">
                  Cancel and select another
              </button>
            </div>            
        </div>
        <div v-else>
            <h1>You have not selected a repair opion yet...</h1>

        </div>
    </div>
</template>
<script>
import repairOptionsBase from '@/mixins/repairOptionsBase'
// import { mapActions } from 'vuex'
import axios from 'axios'
import { authHeader } from '@/util/authHeader'

// TEMP!!
import { repairOptionsService } from '@/services/repairOptions-api.service'

export default {
  mixins: [
    repairOptionsBase
  ],
  data: () => {
    return {
      setRepairOptionResponse: null
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      let { path } = from
    
      if (path != '/login') {
        vm.referer = path
      }
    })
  },
  computed: {
    selectedClaim () {
      return this.$store.state.myclaims.selectedClaim
    },
    claimant () {
      return this.$store.state.myclaims.selectedClaim.claimant
    },
    selectedGadget () {
      return this.$store.state.myclaims.selectedGadget
    },
    selectedGadgetId () {
      let { selectedGadget } = this.$store.state.myclaims
      let { params } = this.$route

      if (selectedGadget) {
        return selectedGadget.id
      }

      if (params) {
        return params.id
      }

      return null
    },
    selectedRepairOption: {
      get () {
        return this.$store.state.repairoptions.selectedOption
      },
      set (value) {
        this.setSelectedRepairOption(value)
      }
    },
    repairOptionTitle () {
      let { selectedOption } = this.$store.state.repairoptions
      if (selectedOption) {
        return selectedOption.repairOptionWebDisplayTitle
      }
    },
    repairOptionDetails () {
      let { selectedOption } = this.$store.state.repairoptions
      if (selectedOption) {
        return selectedOption.webContentEntityValue
      }
    },
    totalExcess () {
      if (this.$store.state.repairoptions) {
        return this.$store.state.repairoptions.totalExcess
      }

      return 0
    },
    gadgetRepairOptionTypeId () {
      let { repairOption } = this.selectedGadget
      if (repairOption != null) {
        let { repairOptionTypeId } = repairOption
        return repairOptionTypeId
      }
      return null
    },
    gadgetRepairBookingReference () {
      let { repairOption } = this.selectedGadget
      if (repairOption != null) {
        let { booking } = repairOption
        if (booking != null) {
          return booking.providerBookingRef
        }
      }
      return null
    },
    gadgetRepairBookingOrderId () {
      let { repairOption } = this.selectedGadget
      if (repairOption != null) {
        let { booking } = repairOption
        if (booking != null) {
          let { providerBookingInfo } = booking
          if (providerBookingInfo != null) {
            let infoJson = JSON.parse(providerBookingInfo)
            if (infoJson != null) {
              return infoJson.order_id
            }
          }
        }
      }
      return null
    }
  },
  methods: {
    handleCancelOptionClick (gadgetId, successGoto) {
      let opt = {
        ...this.selectedOption,
        gadgetWebRef: gadgetId,
        claimWebRef: this.selectedClaim.id
      }

      if (this.gadgetRepairOptionTypeId == 1002 && this.gadgetRepairBookingReference != null) {
        repairOptionsService.CancelBooking(this.gadgetRepairBookingOrderId)
        .then( (response) => {
          
          axios
            .get(process.env.VUE_APP_API_BASE_URL + '/api/v1/repairoptions/cancelforgadget/' + gadgetId, { headers: authHeader() })
            .then(response => {
              
              let { success } = response.data.data

              if (success == true) {
                this.loadSelectedClaim(gadgetId)
                if (successGoto) {
                  this.$router.push(successGoto)
                } else {
                  this.$router.push({ path: this.referer })
                }
              }
              
            })
            .catch(error => {
            
            })
        })
      } else {
    
        axios
          .get(process.env.VUE_APP_API_BASE_URL + '/api/v1/repairoptions/cancelforgadget/' + gadgetId, { headers: authHeader() })
          .then(response => {
            
            let { success } = response.data.data

            if (success == true) {
              this.loadSelectedClaim(gadgetId)
              if (successGoto) {
                this.$router.push(successGoto)
              } else {
                this.$router.push({ path: this.referer })
              }
            }
            
          })
          .catch(error => {
          
          })

          // axios
          //   .get(process.env.VUE_APP_API_BASE_URL + '/api/v1/repairoptions/cancelforgadget/' + gadgetId, { headers: authHeader() })
          //   .then(response => {
              
          //     let { success } = response.data.data

          //     if (success == true) {
                
          //       if (successGoto) {
          //         this.$router.push(successGoto)
          //       } else {
          //         this.$router.push({ path: this.referer })
          //       }
          //     }
              
          //   })
          //   .catch(error => {
            
          //   })
      }
    }
  }
}
</script>
